"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRequestHeaders = exports.ONE_MONTH_IN_MS = exports.DAY_IN_MS = void 0;
exports.DAY_IN_MS = 24 * 60 * 60 * 1000;
exports.ONE_MONTH_IN_MS = 30 * exports.DAY_IN_MS;
const getCloudfareHeaders = (headers) => {
    const headersArr = Object.entries(headers);
    const cfHeaders = headersArr.filter(([key]) => key.includes("cf-"));
    return Object.fromEntries(cfHeaders);
};
const getTraceHeaders = (traceparent) => {
    return {
        traceparent: traceparent || "",
    };
};
const getRequestHeaders = (headers, traceparent) => {
    return {
        ...getCloudfareHeaders(headers),
        ...getTraceHeaders(traceparent),
    };
};
exports.getRequestHeaders = getRequestHeaders;
//# sourceMappingURL=index.js.map